/* ------------------------------------------------------------------------
   PRSPR CRO draft 2026-10-12 (workstream T4). Loaded deferred from
   layout/theme.liquid. Pairs with assets/prspr-cro.css.
   O1/O4  html.prspr-drawer-open while the Rebuy or theme cart drawer is open,
          so the CSS can keep Alia, chat and rewards widgets off the drawer.
   O6     The header bag icon opens the Rebuy drawer (one cart). The theme
          drawer stays as the fallback when Rebuy Smart Cart is not running.
   O7     Re-applies the Seal guard (primary copy is inline in theme.liquid's
          <head>) so the buy box's selling_plan radios survive Seal's widget.
   Every block is independent and fails quietly; the store works without it.
   ------------------------------------------------------------------------ */
(() => {
  'use strict';
  if (window.__PRSPR_CRO__) return;
  const html = document.documentElement;

  /* ---------- template flags (the body already carries them on theme.liquid) */
  try {
    const template = document.getElementById('MainContent')?.dataset.template || '';
    const [name, suffix = ''] = template.split('.');
    if (name === 'product') html.classList.add('prspr-t-product');
    if (name === 'page' && /^(offer|conversion)/.test(suffix)) html.classList.add('prspr-t-offer');
    if (/campaign/.test(suffix)) html.classList.add('prspr-t-campaign');
  } catch (_) {}

  /* ---------- O7: keep the buy box's selling_plan inputs away from Seal */
  const PLAN_INPUTS = 'input[name="selling_plan"][data-pbb-freq], input[name="selling_plan"][data-pbb-plan]';
  function markPlanInputs(root = document) {
    root.querySelectorAll?.(PLAN_INPUTS).forEach((input) => {
      if (!input.hasAttribute('data-sls-selling_plan')) input.setAttribute('data-sls-selling_plan', 'prspr');
    });
  }
  markPlanInputs();

  /* ---------- O1/O4: drawer-open state */
  function rebuyOpen() {
    return document.body.classList.contains('rebuy-cart-visible') ||
      Boolean(document.querySelector('#rebuy-cart.is-visible'));
  }
  function themeDrawerOpen() {
    const drawer = document.getElementById('cart-drawer');
    return Boolean(drawer && (drawer.hasAttribute('open') || drawer.querySelector('dialog[open]')));
  }
  let frame = 0;
  function syncDrawerState() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      html.classList.toggle('prspr-drawer-open', rebuyOpen() || themeDrawerOpen());
    });
  }
  const observer = new MutationObserver(syncDrawerState);
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  const themeDrawer = document.getElementById('cart-drawer');
  if (themeDrawer) observer.observe(themeDrawer, { attributes: true, subtree: true, attributeFilter: ['open'] });
  // #rebuy-cart is injected after load; watch its class too once it exists.
  const bodyChildren = new MutationObserver(() => {
    const rebuyCart = document.getElementById('rebuy-cart');
    if (!rebuyCart) return;
    observer.observe(rebuyCart, { attributes: true, attributeFilter: ['class'] });
    bodyChildren.disconnect();
    syncDrawerState();
  });
  if (document.getElementById('rebuy-cart')) {
    observer.observe(document.getElementById('rebuy-cart'), { attributes: true, attributeFilter: ['class'] });
  } else {
    bodyChildren.observe(document.body, { childList: true });
  }
  syncDrawerState();

  /* ---------- O6: header bag icon opens the Rebuy drawer */
  const CART_TRIGGER = '[data-testid="cart-drawer-trigger"], header-actions .action__cart, header-actions cart-icon';
  function rebuyReady() {
    return typeof window.Rebuy?.SmartCart?.show === 'function' &&
      document.body.classList.contains('smart-cart--enabled');
  }
  function rebuyExpected() {
    // After window load, a missing window.Rebuy means Rebuy failed or is off:
    // let the theme drawer open straight away.
    if (window.Rebuy) return true;
    return document.readyState !== 'complete' && Boolean(document.querySelector('script[src*="rebuyengine.com"]'));
  }
  function openThemeDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
  }
  function openRebuy() {
    try {
      window.Rebuy.SmartCart.show();
      return true;
    } catch (_) {
      return false;
    }
  }
  window.addEventListener('click', (event) => {
    const trigger = event.target.closest?.(CART_TRIGGER);
    if (!trigger || !trigger.closest('header-actions, #header-group, header')) return;
    if (!rebuyReady() && !rebuyExpected()) return; // no Rebuy on this page: theme drawer as usual
    event.preventDefault();
    event.stopImmediatePropagation();
    if (rebuyReady() && openRebuy()) return;
    // Rebuy is still loading: wait up to 4 s, then fall back to the theme drawer.
    const started = Date.now();
    const timer = window.setInterval(() => {
      if (rebuyReady() && openRebuy()) {
        window.clearInterval(timer);
      } else if (Date.now() - started > 4000) {
        window.clearInterval(timer);
        openThemeDrawer();
      }
    }, 150);
  }, true);

  window.__PRSPR_CRO__ = { syncDrawerState, markPlanInputs, rebuyReady };
})();
